/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentStreamingResponse {
    getFixupPrototypeFunction() { return AgentStreamingResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentStreamingResponse>): AgentStreamingResponse {
        let obj = Object.assign(new AgentStreamingResponse(), model);
        AgentStreamingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentStreamingResponse>): AgentStreamingResponse {
        if (!model) return null;
        return AgentStreamingResponse.newInstance(<AgentStreamingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentStreamingResponse) {
        if (!obj) return;

        models.AgentStreamingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentStreamingResponse): boolean {
        Object.setPrototypeOf(obj, AgentStreamingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of the streaming data
     */
    type: string;

    /**
     * Streaming data either progress data or response data
     */
    data: any;

}
